<template>
    <div>
        {{ showopenmodalcomp }}
        <div v-if="showopenmodal">
            <!-- template for the modal component -->
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog modal-md" style="display: block !important">
                            <div class="modal-content">
                                <!-- Modal Header -->
                                <div class="modal-header pb-0">
                                    <h5 class="modal-title text-center pull-left w-100 d-block mt-4 pb-0">
                                        OPD Card Settings
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal" @click="cancelAction()">
                                        <i class="material-icons">close</i>
                                    </button>
                                </div>
                                <!-- Modal body -->
                                <div class="modal-body p-0">
                                    <div>
                                        <div v-if="showspinner" class="appointmentlist-spinner">
                                            <div class="processing_popup full-spinner" style="
                                                    visibility: visible;
                                                    top: -68px;
                                                    height: 261px;
                                                    z-index: 9999999999;
                                                ">
                                                <div class="spinner cover-spin">
                                                    <div class="bounce1"></div>
                                                    <div class="bounce2"></div>
                                                    <div class="bounce3"></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <label v-for="section in sections" :key="section.value"
                                                class="container customcheck mart-10 float-none">
                                                <span>{{ section.label }}</span>
                                                <input type="checkbox" :value="section.value"
                                                    v-model="selectedSections" />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>

                                        <div class="col-md-12 mt-3">
                                            <label class="container customcheck mart-10 float-none">
                                                <span>Display Custom OPD Timings Text?</span>
                                                <input type="checkbox" v-model="displayCustomOpdTimingText" />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>

                                        <div class="col-md-12 mt-2" v-if="displayCustomOpdTimingText">
                                            <input type="text" class="form-control"
                                                placeholder="Enter custom OPD timing text" v-model="customOpdTimingText"
                                                maxlength="100" />
                                            <small class="text-muted">
                                                {{ customOpdTimingText.length }}/100
                                            </small>
                                        </div>

                                        <div class="col-md-12 mt-3">
                                            <label class="container customcheck mart-10 float-none">
                                                <span>Display Vitals in Single Line?</span>
                                                <input type="checkbox" v-model="displayVitalsInSingleLine" />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="col-md-12 mt-3">
                                            <label class="container customcheck mart-10 float-none">
                                                <span>Display serial number ?</span>
                                                <input type="checkbox" v-model="displaySerialNumber" />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>

                                        <div class="pull-left mb-4 pl-5 pr-5 col-md-12 mt-2">
                                            <slot name="footer">
                                                <button type="button" class="primary-btn ripple pull-right"
                                                    @click="saveSettings()">
                                                    Save
                                                </button>
                                            </slot>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- <transition name="fade"> -->
        <Messages v-if="isdisplaymsg" v-bind:datamessage="sucessmsgtext" v-bind:iserror="iserrormsg"
            v-on:closemsg="closeMessage" v-bind:isVisible="isdisplaymsg"></Messages>
        <!-- </transition> -->
    </div>
</template>


<script>
import rest_service from "@/api/rest_service";
import Axios from "axios";
import Messages from "@/components/MessagePopup/Messages";
import SubscriptionApi from "../../api/subscription.js";

export default {
    props: ["showmodal", "parentprop"],
    components: { Messages },
    data() {
        return {
            isdisplaymsg: false,
            sucessmsgtext: "",
            iserrormsg: false,
            showopenmodal: false,
            loggedInUser: null,
            showspinner: false,
            sections: [],
            selectedSections: [],
            displayCustomOpdTimingText: false,
            customOpdTimingText: "",
            displayVitalsInSingleLine: false,
            displaySerialNumber:false
        };
    },
    methods: {
        cancelAction() {
            this.showopenmodal = false;
            this.parentprop.opencloseOpdSettingsModal = false;
        },
        getBusinessSetup() {
            this.showspinner = true;
            SubscriptionApi.getbusinesssetup()
                .then((response) => {
                    if (response.data && response.data.result) {
                        localStorage.setItem("tenantbusinesssetup", JSON.stringify(response.data.result));
                        var tenantbusinesssetup = JSON.parse(window.localStorage.getItem("tenantbusinesssetup"));
                        if (tenantbusinesssetup) {
                            if (tenantbusinesssetup.opdCardSections)
                                this.selectedSections = tenantbusinesssetup.opdCardSections

                            if (tenantbusinesssetup.displayCustomOpdTimingText)
                                this.displayCustomOpdTimingText = tenantbusinesssetup.displayCustomOpdTimingText || false;

                            if (tenantbusinesssetup.customOpdTimingText)
                                this.customOpdTimingText = tenantbusinesssetup.customOpdTimingText || "";

                            if (tenantbusinesssetup.displayVitalsInSingleLine)
                                this.displayVitalsInSingleLine = tenantbusinesssetup.displayVitalsInSingleLine || false;

                            if (tenantbusinesssetup.displaySerialNumber)
                                this.displaySerialNumber = tenantbusinesssetup.displaySerialNumber || false;
                        }
                    }
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.showspinner = false;
                });
        },
        getOPDCardSettings() {
            var self = this;
            self.showspinner = true;

            Axios.request({
                method: "get",
                url: rest_service.baseURL + "/staff/get-opd-card-sections",
                headers: {
                    x_tenant_id: localStorage.tenantid,
                    role_unique_id: this.loggedInUser.role.unique_id,
                    route_entity_name: "/get-opd-card-sections",
                    loggedin_user_unique_id: this.loggedInUser.unique_id,
                    Authorization: localStorage.accesstoken,
                }
            })
                .then((respo) => {
                    if (
                        respo.data &&
                        respo.status) {
                        self.showspinner = false;
                        self.sections = respo.data;
                    }
                })
                .catch((ex) => {
                    self.showspinner = false;
                    self.isdisplaymsg = true;
                    self.iserrormsg = true;
                    self.sucessmsgtext =
                        "Unable to to get OPD card settings";
                    setTimeout(
                        function () {
                            self.closeMessage();
                        }.bind(self),
                        3000
                    );
                })
        },
        saveSettings() {
            var self = this;
            self.showspinner = true;

            Axios.request({
                method: "put",
                url: rest_service.baseURL + "/staff/updateopdcardsettings",
                headers: {
                    x_tenant_id: localStorage.tenantid,
                    role_unique_id: this.loggedInUser.role.unique_id,
                    route_entity_name: "/updateopdcardsettings",
                    loggedin_user_unique_id: this.loggedInUser.unique_id,
                    Authorization: localStorage.accesstoken,
                },
                withCredentials: false,
                data: {
                    sections: this.selectedSections,
                    displayCustomOpdTimingText: this.displayCustomOpdTimingText,
                    customOpdTimingText: this.displayCustomOpdTimingText
                        ? this.customOpdTimingText
                        : null,
                    displayVitalsInSingleLine: this.displayVitalsInSingleLine,
                    displaySerialNumber: this.displaySerialNumber
                }
            })
                .then((respo) => {
                    if (
                        respo.data &&
                        respo.data.result &&
                        respo.status) {
                        window.localStorage.removeItem("tenantbusinesssetup");
                        self.showspinner = false;
                        localStorage.setItem("tenantbusinesssetup", JSON.stringify(respo.data.result));
                        self.parentprop.opencloseOpdSettingsModal = false;
                        self.isdisplaymsg = true;
                        self.iserrormsg = false;
                        self.sucessmsgtext =
                            "OPD Card Settings " +
                            self.$store.state.helper.alertmessage.saved;
                        setTimeout(
                            function () {
                                self.closeMessage();
                            }.bind(self),
                            3000
                        );
                    } else {
                        self.showspinner = false;
                        self.parentprop.opencloseOpdSettingsModal = false;
                        self.isdisplaymsg = true;
                        self.iserrormsg = true;
                        self.sucessmsgtext =
                            respo.data.result
                        setTimeout(
                            function () {
                                self.closeMessage();
                            }.bind(self),
                            3000
                        );

                    }
                })
                .catch((ex) => {
                    self.showspinner = false;
                    self.parentprop.opencloseOpdSettingsModal = false;
                    self.isdisplaymsg = true;
                    self.iserrormsg = true;
                    self.sucessmsgtext =
                        "OPD Card Settings " +
                        self.$store.state.helper.alertmessage.failupdate;
                    setTimeout(
                        function () {
                            self.closeMessage();
                        }.bind(self),
                        3000
                    );
                })

        },
        closeMessage() {
            this.isdisplaymsg = false;
        },

    },
    created() {
        
    },
    mounted() {
        this.loggedInUser = JSON.parse(localStorage.loggedInUserInfo);
        var tenantbusinesssetup = JSON.parse(window.localStorage.getItem("tenantbusinesssetup"));
        if (tenantbusinesssetup) {
            if (tenantbusinesssetup.opdCardSections)
                this.selectedSections = tenantbusinesssetup.opdCardSections

            if (tenantbusinesssetup.displayCustomOpdTimingText)
                this.displayCustomOpdTimingText = tenantbusinesssetup.displayCustomOpdTimingText || false;

            if (tenantbusinesssetup.customOpdTimingText)
                this.customOpdTimingText = tenantbusinesssetup.customOpdTimingText || "";

            if (tenantbusinesssetup.displayVitalsInSingleLine)
                this.displayVitalsInSingleLine = tenantbusinesssetup.displayVitalsInSingleLine || false;

            if (tenantbusinesssetup.displaySerialNumber)
                this.displaySerialNumber = tenantbusinesssetup.displaySerialNumber || false;
        }
        else
            this.getBusinessSetup();
        this.getOPDCardSettings();
    },
    computed: {
        showopenmodalcomp() {
            var self = this;
            self.showopenmodal = self.showmodal;
            if (self.showopenmodal) {
                self.showspinner = false;
                //self.getBusinessSetup();
            }
        }
    }
};
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 300px;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
}

.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-body {
    margin: 20px 0;
}

.modal-default-button {
    float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.modal-container.modal-width500 {
    max-width: 650px;
    width: 100%;
}

.modal-container.modal-width500 .modal-header {
    border-bottom: 1px solid transparent !important;
    padding-bottom: 0px !important;
}

.modal-container.modal-width500 .modal-footer {
    border-top: 1px solid transparent !important;
}

.modal-container.modal-width500 .modal-header {
    min-height: 10px !important;
}

.modal-container.modal-width500 .modal-body {
    margin: 0px !important;
}

.select .sector-select {
    color: #000 !important;
}

.category-select-default.single .select-txt {
    position: relative;
    z-index: 999999999;
    top: -45px;
    display: block;
    color: #000 !important;
    width: 90%;
    height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.category-select-default.single .select-txt {
    color: #777;
}

input[type="checkbox"],
input[type="radio"] {
    height: 19px !important;
    width: 100%;
    left: 0px;
    z-index: 1;
}
</style>